import { StorageHelper } from './StorageHelper';
export class FilterHelper {
  static saveFilterOpen(open: boolean) {
    StorageHelper.getInstance().save(StorageHelper.keys.filterOpen, open? "true" : "false");
  }

  static getFilterOpen(): boolean {
    return StorageHelper.getInstance().get(StorageHelper.keys.filterOpen) == "true";
  }
}
